import { Log, apiRequest } from '@ext/utils'; import { Paginacion } from '@ext/env';
export * from './Publicacion.types'
import * as Types from './Publicacion.types'
import { IPublicacion } from './Publicacion.lib';

export class Publicacion extends IPublicacion {

 

    public static Route = `/web/web/publicaciones`;
    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Publicacion>; Error?: boolean; }>
    {

        let a: Array<Publicacion> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/web/web/publicaciones` );
        request.params = params;
        if ( await request.get() ) {
            if ( request.data.response ) {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results ) {
                for ( let i of request.data.results ) {
                    let p = new Publicacion( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save(): Promise<boolean>
    {

        try
        {
            let js = this.getJson();
            let req = new apiRequest();
            req.body = js;
            if ( this.Existe )
            {
                req.path = `${Publicacion.Route}/${this.Id}`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    this.set();
                    return true;
                }
            }
            else
            {
                req.path = `${Publicacion.Route}`;
                console.log( req.path );
                if ( await req.post() )
                {
                    this.Json = req.data;
                    this.set();
                    return true;
                }
            }
            
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${Publicacion.Route}/${this.Id}`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async Activar(): Promise<boolean>
    {
        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${Publicacion.Route}/${this.Id}`;
                req.params.estado = 'activa';
                if ( await req.put() )
                {
                    this.Estado = Types.Estados.Activa;
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async Pausar(): Promise<boolean>
    {
        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${Publicacion.Route}/${this.Id}`;
                req.params.estado = 'pausada';
                if ( await req.put() )
                {
                    this.Estado = Types.Estados.Pausada;
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }
}